import React, { useState, useEffect, useRef } from "react";


// import "./Company.css";
// import "./Style.css";
import axios from "axios";
import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";


import Terms from "../Food/Terms";
import Refund from "../Food/Cancelrefund";

import { jsPDF } from "jspdf";
import { Link } from "react-router-dom";
import { Scale } from "@mui/icons-material";
import Registration from "../Food/Registration";
import { Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Cateringprofile = () => {
    const [activeTab, setActiveTab] = useState("Registration");
    const [verifyingIndex, setVerifyingIndex] = useState(null);
    const [editRowIndex, setEditRowIndex] = useState(null);
    const [permissions, setPermissions] = useState({});
    const [editingIndex, setEditingIndex] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pricingData, setPricingData] = useState([]);
    const isMobile = window.innerWidth <= 768;

    const [messages, setMessages] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [ticketType, setTicketType] = useState("");
    const [message, setMessage] = useState("");
    const [attachment, setAttachment] = useState(""); // base64 image

    const [orderPosts, setOrderPosts] = useState([]);
    const [expandedCard, setExpandedCard] = useState(null);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };
    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate("/subscriptionrenewal");
    };

    const getOfferColor = (type) => {
        return "#b15cd6";
    };

    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const vendorId = localStorage.getItem("vendorId"); // get vendorId from localStorage

                if (!vendorId) {
                    console.error("🚨 vendorId not found in localStorage!");
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/coupon/vendor/${vendorId}/active`
                );

                setOrderPosts(response.data);
            } catch (error) {
                console.error("❌ Failed to fetch coupons:", error);
            }
        };

        fetchCoupons();
    }, []);




    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                // Ensure we only get base64 data (after the comma)
                const base64Data = result.split(',')[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };



    const handleSendTicket = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "", // base64 encoded image
        };

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                console.error("API Error:", result);
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        }
    };



    const [companyName, setCompanyName] = useState("");
    const token = localStorage.getItem("authToken");
    const [error, setError] = useState(null);
    const planOptions = ["BASIC", "STANDARD", "PREMIUM"];
    const [vendorId, setVendorId] = useState(null);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);

    const API_URL = "https://backend.maamaas.com/food/api/subscription-plans";


    useEffect(() => {
        axios
            .get("https://backend.maamaas.com/food/api/subscription-plans")
            .then((response) => {
                console.log("API Response:", response.data);
                setPricingData(response.data || []);
                setYearlyToggles(new Array(response.data.length).fill(false)); // default to monthly
            })
            .catch((error) => {
                console.error("Error fetching subscription plans:", error);
            });
    }, []);





    const loadRazorpay = () => {
        const vendorId = localStorage.getItem("vendorId") || 91;
        const rawPlanId = localStorage.getItem("subscriptionPlanId");
        const subscriptionPlanId = rawPlanId != null ? Number(rawPlanId) : 1;
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("⚠️ Authentication token missing! Please login again.");
            return;
        }

        console.log("🔍 subscriptionPlanId from localStorage:", subscriptionPlanId);
        console.log("📦 pricingData:", pricingData);

        const selectedPlan = pricingData.find(
            (plan) => Number(plan.id) === subscriptionPlanId
        );

        console.log("✅ selectedPlan:", selectedPlan);

        if (!selectedPlan || selectedPlan.price == null) {
            alert("❌ Selected subscription plan is invalid or missing price.");
            return;
        }




        const amount = selectedPlan.price * 100;

        const options = {
            key: "rzp_test_vbkGmNwNGHs88H",
            amount: amount,
            currency: "INR",
            name: "Mama's Website",
            description: "Subscription Payment",
            handler: function (response) {
                const payload = {
                    vendorId: Number(vendorId),
                    subscriptionPlanId: subscriptionPlanId,
                    transactionId: response.razorpay_payment_id,
                    amount: amount,
                    status: "PENDING",
                };

                axios
                    .post(
                        "https://backend.maamaas.com/food/api/payments/create",
                        payload,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((res) => {
                        alert("🎉 Subscription successful!");
                    })
                    .catch((err) => {
                        console.error("❌ Error subscribing:", err.response?.data || err);
                        alert("❌ Subscription failed. Check console for details.");
                    });
            },
            prefill: {
                name: "Customer Name",
                email: "customer@example.com",
                contact: "9999999999",
            },
            theme: {
                color: "#3399cc",
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };



    const [yearlyToggles, setYearlyToggles] = useState(
        pricingData.map(() => false)
    );

    const categories = [
        "Food",
        "Rooms",
        "Banquet Halls",
        "Fashions",
        "Groceries",
    ];

    const [subscriptions, setSubscriptions] = useState([]);
    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const vendorId = localStorage.getItem("vendorId"); // ✅ Retrieve vendorId

                if (!token || !vendorId) {
                    console.warn("Missing token or vendorId");
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/subscriptions/getsubscriptions/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("API Response:", response.data);

                const data = response.data;
                if (Array.isArray(data)) {
                    setSubscriptions(data);
                } else if (data && Array.isArray(data.subscriptions)) {
                    setSubscriptions(data.subscriptions);
                } else if (data) {
                    setSubscriptions([data]);
                } else {
                    setSubscriptions([]);
                }
            } catch (error) {
                console.error(
                    "Failed to fetch subscriptions:",
                    error.response?.data || error.message
                );
                setSubscriptions([]);
            }
        };

        fetchSubscriptions();
    }, []);



    const verticalOptions = ["Food", "Rooms", "Rentals", "Events"];


    // 2️⃣  Update via the setter
    const handleChange = (id, field, value) => {
        setSubscriptions(prev =>
            prev.map(sub =>
                sub.id === id ? { ...sub, [field]: value } : sub
            )
        );
    };
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        }

        startScrolling();


        return () => clearInterval(interval);
    }, [isHovered]);



    const generatePDF = () => {


        const doc = new jsPDF();

        // --- Title ---
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Invoice Summary", 105, 20, { align: "center" });

        // --- Core details ---
        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        const data = {
            owner: "Vamshikrishna",
            company: "Maamaas House",
            vertical: "Food & Beverage",
            plan: "Premium Annual",
            amount: "₹25,000.00"
        };

        let y = 40;
        const lineGap = 10;

        // Extract numeric value from currency string (remove ₹ and commas)
        const numericAmount = parseFloat(data.amount.replace(/[^0-9.-]+/g, ""));
        const taxRate = 0.0625;
        const taxAmount = numericAmount * taxRate;
        const totalAmount = numericAmount + taxAmount;

        // Format amounts to 2 decimal places with currency symbol
        const formatCurrency = (value) => `₹${value.toFixed(2)}`;

        Object.entries(data).forEach(([label, value]) => {
            doc.text(`${label.charAt(0).toUpperCase() + label.slice(1)}:`, 20, y);
            doc.text(value, 80, y);
            y += lineGap;
        });

        // Subtotal and taxes
        doc.text("Subtotal", 140, y + 5, { align: "right" });
        doc.text(formatCurrency(numericAmount), 190, y + 5, { align: "right" });

        doc.text("Sales Tax 6.25%", 140, y + 12, { align: "right" });
        doc.text(formatCurrency(taxAmount), 190, y + 12, { align: "right" });

        doc.setFont("helvetica", "bold");
        doc.text("TOTAL", 140, y + 20, { align: "right" });
        doc.text(formatCurrency(totalAmount), 190, y + 20, { align: "right" });

        // Signature placeholder
        doc.setFont("helvetica", "normal");
        doc.text("John Smith", 140, y + 45);

        // Footer text
        doc.setFontSize(8);
        doc.text("Terms & Conditions", 10, y + 60);
        doc.text("Payment is due within 15 days.", 10, y + 65);
        doc.text("Please make checks payable to: Maamaas House", 10, y + 70);

        // Save or output the PDF
        doc.save("custom_invoice.pdf");
    };


    const initiatePayment = async () => {
        setLoading(true);

        // Payment and transaction details

        // Razorpay Payment Options for paid courses
        var options = {
            key: "rzp_test_oqm83qg9Z710lA",
            key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
            amount: 2 * 100, // Convert price to paise
            currency: "INR",
            payment_capture: true,
            name: "MAAMAAS HOUSE",
            handler: async function (response) {
                alert(
                    "Thanks For Your Interest \n Your Payment has been successfully completed"
                );
                generatePDF();
                setActiveTab("Registration");

                // Call API to update payment status

            },
            notes: {
                address: "MAAMAAS HOUSE",
            },
            theme: {
                color: "#b15cd6",
            },
        };

        var pay = new window.Razorpay(options);
        pay.open();
    }



    const scrollRef = useRef(null);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        const scrollSpeed = 1; // px per tick
        const scrollInterval = 20; // ms
        let scroll;

        const startScroll = () => {
            scroll = setInterval(() => {
                container.scrollTop += scrollSpeed;

                // When scroll reaches half (original content height), reset to top for seamless loop
                if (container.scrollTop >= container.scrollHeight / 2) {
                    container.scrollTop = 0;
                }
            }, scrollInterval);
        };

        startScroll();

        return () => clearInterval(scroll);
    }, [orderPosts]);





    // {=======================overview===============================}
    const tabContent = {
        // "POS Billng": <Digialmenubillingspage />,


        Registration: <Registration onNext={() => {
            console.log("Registration: Next clicked, changing to Terms And Conditions");
            setActiveTab("Terms And Conditions"); // Use the string key
        }} />,

        "Terms And Conditions": <Terms
            onNext={() => {
                console.log("Terms: Next clicked, changing to Cancel/Refund");
                setActiveTab("Cancel/Refund"); // Use the string key
            }}
            onBack={() => { // Example for a back button
                console.log("Terms: Back clicked, changing to Registration");
                setActiveTab("Registration");
            }}
        />,

        "Cancel/Refund": <Refund
            onFinish={() => { // Example for a finish button
                console.log("Refund: Finish clicked, changing to Subscription");
                setActiveTab("Subscription"); // Go to another tab after finishing
            }}
            onBack={() => {
                console.log("Refund: Back clicked, changing to Terms And Conditions");
                setActiveTab("Terms And Conditions");
            }}
        />,
        // ... other tabs

        Summary: (
            <div>
                {subscriptions.length === 0 ? (
                    <p>No subscriptions found.</p>
                ) : (
                    subscriptions.map((sub, index) => (
                        <table key={sub?.id || index} style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={headerStyle}>Field</th>
                                    <th style={headerStyle}>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Vendor ID</td>
                                    <td style={cellStyle}>
                                        {sub?.vendorEnquiry?.vendorId || "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Application</td>
                                    <td style={cellStyle}>
                                        <span
                                            style={{
                                                color: sub?.active ? "green" : "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {sub?.active ? "Approved" : "Pending"}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Status</td>
                                    <td style={cellStyle}>
                                        <span
                                            style={{
                                                color: sub?.active ? "green" : "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {sub?.active ? "Active" : "Inactive"}
                                        </span>
                                        <div style={{ marginTop: "-20px" }}>
                                            <button
                                                onClick={handleRedirect} // ✅ keep only one onClick
                                                style={{
                                                    backgroundColor: sub?.active ? "#4CAF50" : "#f44336",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    marginRight: "-120px",
                                                    padding: "5px 10px",
                                                    cursor: "pointer", // better UX
                                                }}
                                            >
                                                Upgrade
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                        Business Verticals
                                    </td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.businessVertical}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Plan</td>
                                    <td style={cellStyle}>{sub?.subscriptionPlan?.planType}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Start Date</td>
                                    <td style={cellStyle}>
                                        {sub?.startDate ? sub.startDate.slice(0, 10) : "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>End Date</td>
                                    <td style={cellStyle}>
                                        {sub?.endDate ? sub.endDate.slice(0, 10) : "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Company Name</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.companyName}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Owner Name</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.name}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                        Phone Number
                                    </td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.mobileNumber}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Email</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.email}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Pincode</td>
                                    <td style={cellStyle}>
                                        {sub?.vendorEnquiry?.pincode || "N/A"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ))
                )}
            </div>

        ),

    };

    return (
        <>
            <div>
                <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: -10px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

                {/* Main Layout */}
                <div className="container-fluid company-mobile-data">
                    <div className="Row">
                        <div className="col-lg-2"></div>
                        <div className="Col-lg-7">

                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                    top: isMobile ? "50px" : "80px",
                                    left: isMobile ? "5px" : "275px",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: isMobile ? "14px" : "18px",
                                    fontWeight: isMobile ? "normal" : "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                <Link
                                    to="/Newmainlandingpage"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Home
                                </Link>

                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Profile
                                </Link>

                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Fresh & Grocery
                                </Link>
                            </p>



                            {/* Left Section */}
                            <div className="left-column" style={{}}>
                                <div className="tabs-wrapper ">

                                    <div className="tab-buttons" style={{}}>
                                        {Object.keys(tabContent).map((label) => (
                                            <button
                                                key={label}
                                                className={`tab-button ${activeTab === label ? "active" : ""}`}
                                                onClick={() => setActiveTab(label)}
                                            >
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                    <div
                                        className="tab-content"
                                        style={{
                                            overflow: 'auto',
                                            height: isMobile ? '700px' : '520px',
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            maxWidth: '944px',
                                        }}
                                    >
                                        {tabContent[activeTab]}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div
                                    style={{
                                        position: "fixed",
                                        bottom: "62px",
                                        right: "16px",
                                        height: "560px",
                                        borderRadius: "8px",
                                        padding: "10px",
                                        marginTop: "40px",
                                    }}
                                    className="scroll-fixed-data mobilescroll"
                                >
                                    <div
                                        ref={scrollRef}
                                        style={{
                                            maxHeight: "570px",
                                            overflowY: "auto",
                                            paddingRight: "5px",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            marginTop: "40px",
                                        }}
                                        className="hide-scrollbar"
                                    >
                                        {orderPosts
                                            .filter((post) => new Date(post.endDate) >= new Date()) // only include non-expired
                                            .map((post, index) => (
                                                <div
                                                    key={`${post.vendorCouponsId}-${index}`}
                                                    onClick={() => toggleCard(index)}
                                                    className="card scroll-data-responsive"
                                                    style={{
                                                        width: "300px",
                                                        marginBottom: "12px",
                                                        background: getOfferColor(post.offerType),
                                                        borderRadius: "10px",
                                                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                        cursor: "pointer",
                                                        transition: "all 0.3s ease",
                                                        padding: "15px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            height: "100%",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <h4 style={{ color: "#fff", marginBottom: "10px" }}>
                                                            {post.gole} Offer 🎉
                                                        </h4>
                                                        <p style={{ color: "#f5f5f5", fontSize: "15px" }}>
                                                            {post.description || "Enjoy discounts on special event!"}
                                                        </p>
                                                        <button
                                                            style={{
                                                                marginTop: "10px",
                                                                backgroundColor: "#f5f5f5",
                                                                color: "#000",
                                                                border: "none",
                                                                padding: "6px 16px",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                alignItems: "center",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            Pay
                                                        </button>
                                                    </div>

                                                    {expandedCard === index && (
                                                        <div
                                                            style={{
                                                                marginTop: "10px",
                                                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                                padding: "10px",
                                                                borderRadius: "8px",
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            <p><strong>Coupon Code:</strong> {post.couponCode}</p>
                                                            <p><strong>Valid From:</strong> {new Date(post.startDate).toLocaleDateString()}</p>
                                                            <p><strong>Valid Until:</strong> {new Date(post.endDate).toLocaleDateString()}</p>
                                                            <p><strong>Discount:</strong> {post.discountPercentage}%</p>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>





                                    {/* Chat Support */}
                                    <div
                                        style={{
                                            position: "fixed",
                                            bottom: "0px",
                                            right: "32px",
                                            width: "300px",
                                            backgroundColor: "#fff",
                                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            transition: "height 0.3s ease-in-out",
                                            height: isOpen ? "400px" : "50px",
                                            zIndex: 9999,
                                        }}
                                    >
                                        {/* Header with Toggle Button */}
                                        <div
                                            style={{
                                                backgroundColor: "#b15cd6",
                                                color: "#fff",
                                                padding: "10px",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            <FaCommentAlt style={{ marginLeft: "10px" }} />
                                            <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                                            {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
                                        </div>

                                        {/* Chat Content */}
                                        {isOpen && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: 1,
                                                    overflowY: "auto",
                                                    padding: "10px",
                                                    height: "352px",
                                                    scrollbarWidth: "none"
                                                }}
                                            >
                                                <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

                                                {/* Ticket Type Dropdown */}
                                                <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                                <select
                                                    value={ticketType}
                                                    onChange={(e) => setTicketType(e.target.value)}
                                                    style={{
                                                        marginBottom: "10px",
                                                        padding: "8px",
                                                        borderRadius: "5px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                    }}
                                                >
                                                    <option value="">Select Ticket Type</option>
                                                    <option value="PAYOUT_ISSUE">Payout Issue</option>
                                                    <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                                    <option value="ORDER_COMPLAINT">Order Complaint</option>
                                                    <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                                    <option value="OTHER">Other</option>
                                                </select>

                                                {/* Message Input */}
                                                <label style={{ fontWeight: "bold" }}>Message</label>
                                                <input
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    placeholder="Type your Issue here..."
                                                    rows={3}
                                                    style={{
                                                        marginBottom: "10px",
                                                        padding: "8px",
                                                        borderRadius: "5px",
                                                        border: "1px solid #ccc",
                                                        height: "50px"

                                                    }}
                                                />

                                                {/* Attachment Upload */}
                                                <label style={{ fontWeight: "bold" }}>Attachment</label>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    style={{ marginBottom: "10px" }}
                                                />

                                                {/* Submit Button */}
                                                <button
                                                    onClick={handleSendTicket}
                                                    style={{
                                                        padding: "10px",
                                                        backgroundColor: "#b15cd6",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        fontWeight: "bold",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Send Ticket
                                                </button>
                                            </div>
                                        )}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};



const evenRowStyle = {

};

const oddRowStyle = {

};
const rowStyle = {
    borderBottom: "1px solid #ccc",
    padding: "8px",
};
const inputStyle = {
    width: "100%",
    border: "none",
    backgroundColor: "transparent",
    textAlign: "center",
};
const buttonStyle = {
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "5px",
};
const buttonStyle1 = {
    backgroundColor: "green",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "5px",
};
const addButtonStyle = {
    marginBottom: "10px",

    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    width: "100px",
};
const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "30px",
    border: "1px solid #ddd",
};

const headerStyle = {
    backgroundColor: "#b15dc6",
    padding: "10px",
    border: "1px solid #ccc",
    textAlign: "Center",
    fontWeight: "bold"
};

const cellStyle = {
    padding: "10px",
    border: "1px solid #ccc",
};

const deleteButtonStyle = {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
};
const iconButtonStyle = {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "18px",
    marginRight: "8px",
    color: "#333",
};

const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
};

const modalContentStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "300px",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
};




export default Cateringprofile;
